var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1112 10.4295C52.0707 10.1328 51.8549 9.90348 51.5582 9.84953C43.4115 8.46027 28.8311 1.21728 26.5651 0.0708114C26.3763 -0.0236038 26.147 -0.0236038 25.9582 0.0708114C23.6922 1.21728 9.11181 8.46027 0.951644 9.84953C0.654911 9.90348 0.439105 10.1328 0.398641 10.4295C-0.16785 15.1233 -3.51284 51.4596 25.9852 63.9494C26.147 64.0169 26.3358 64.0169 26.5112 63.9494C56.0362 51.4596 52.6777 15.1233 52.1112 10.4295ZM46.9318 33.3589C43.7757 46.105 36.8294 55.0474 26.2684 59.93C15.6939 55.0339 8.74764 46.105 5.59148 33.3589C3.50085 24.9155 3.6762 16.9576 3.95944 13.0731C11.5666 11.1713 22.0332 6.22129 26.2684 4.14415C30.5036 6.22129 40.9702 11.1579 48.5774 13.0731C48.8471 16.9576 49.0225 24.9155 46.9318 33.3589Z",
    fill: "url(#paint0_linear_7385_165604)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2548 5.95166C21.8847 8.08275 12.7129 12.3314 5.48342 14.3411C5.26761 18.4684 5.30807 25.5226 7.14243 32.9814C10.1098 44.9451 16.53 53.4155 26.2413 58.1498C35.9525 53.4155 42.3728 44.9451 45.3401 32.9814C47.188 25.5226 47.2284 18.4684 47.0126 14.3411C39.8101 12.3314 30.6383 8.06926 26.2548 5.95166ZM22.4242 40.5481L13.9268 32.0507L17.5146 28.6248L22.7614 33.2916L37.1125 18.6842L40.6868 22.2585L22.4242 40.5481Z",
    fill: "url(#paint1_linear_7385_165604)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7385_165604",
    x1: 38.4879,
    y1: -0.309412,
    x2: 37.6737,
    y2: 72.6754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DF0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA0C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7385_165604",
    x1: 35.9638,
    y1: 5.69931,
    x2: 35.2819,
    y2: 65.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DF0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA0C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliant);
export default __webpack_public_path__ + "static/media/compliant.861fc0c30f91ac8ef8ab6a03bc39b0ae.svg";
export { ForwardRef as ReactComponent };